<template>
  <div id="ResPatterns">
    <div v-if="type.type == 'ssc'">
      <table border="0" cellpadding="1" cellspacing="1">
        <tr>
          <th colspan="3">总和</th>
          <th>龙虎</th>
          <th>前三</th>
          <th>中三</th>
          <th>后三</th>
        </tr>
        <tr>
          <td>{{ count(arr) }}</td>
          <td>{{ singleDouble(count(arr)) | formatSingleDouble }}</td>
          <td>{{ smallBig(count(arr), 45) | formatSmallBig }}</td>
          <td>{{ dragonTiger(arr[0], arr[arr.length - 1]) | formatDragonTiger }}</td>
          <td>{{ continuityCnname(continuity([arr[0], arr[1], arr[2]])) }}</td>
          <td>{{ continuityCnname(continuity([arr[1], arr[2], arr[3]])) }}</td>
          <td>{{ continuityCnname(continuity([arr[2], arr[3], arr[4]])) }}</td>
        </tr>
      </table>
    </div>
    <div v-if="type.type == 'PK10' || type.type == 'nn'">
      <table border="0" cellpadding="1" cellspacing="1">
        <tr>
          <th colspan="5">1-5龙虎</th>
          <th>冠亚和</th>
        </tr>
        <tr>
          <td>{{ dragonTiger(arr[0], arr[9]) | formatDragonTiger }}</td>
          <td>{{ dragonTiger(arr[1], arr[8]) | formatDragonTiger }}</td>
          <td>{{ dragonTiger(arr[2], arr[7]) | formatDragonTiger }}</td>
          <td>{{ dragonTiger(arr[3], arr[6]) | formatDragonTiger }}</td>
          <td>{{ dragonTiger(arr[4], arr[5]) | formatDragonTiger }}</td>
          <td>{{ count([arr[0], arr[1]]) }}</td>
        </tr>
      </table>
    </div>
    <div v-if="type.type == 'three'">
      <table v-if="type.gameType == 'PL5'" border="0" cellpadding="1" cellspacing="1">
        <tr>
          <th colspan="2">总和</th>
        </tr>
        <tr>
          <td>{{ count(arr) }}</td>
          <td>{{ singleDouble(count(arr)) | formatSingleDouble }}</td>
        </tr>
      </table>

      <table v-else border="0" cellpadding="1" cellspacing="1">
        <tr>
          <th colspan="3">总和</th>
        </tr>
        <tr>
          <td>{{ count(arr) }}</td>
          <td>{{ singleDouble(count(arr)) | formatSingleDouble }}</td>
          <td>{{ smallBig(count(arr), 27) | formatSmallBig }}</td>
        </tr>
      </table>
    </div>
    <div v-if="type.type == 'xyrb'">
      <table border="0" cellpadding="1" cellspacing="1">
        <tr>
          <th colspan="3">总和</th>
        </tr>
        <!-- <span>{{arr}}</span> -->

        <tr>
          <td>{{ count(arr) }}</td>
          <td>{{ singleDouble(count(arr)) | formatSingleDouble }}</td>
          <!-- <td>{{smallBig(count(arr,27)) | formatSmallBig}}</td> -->
          <td>{{ smallBig(count(arr), 27) | formatSmallBig }}</td>
        </tr>
      </table>
    </div>
    <div v-if="type.type == 'choose5'">
      <table border="0" cellpadding="1" cellspacing="1">
        <tr>
          <th colspan="3">总和</th>
        </tr>
        <tr>
          <td>{{ count(arr) }}</td>
          <td>{{ singleDouble(count(arr)) | formatSingleDouble }}</td>
          <td>{{ smallBig(count(arr), 30) | formatSmallBig }}</td>
        </tr>
      </table>
    </div>
    <div v-if="type.type == 'ks'">
      <table border="0" cellpadding="1" cellspacing="1">
        <tr>
          <th colspan="3">总和</th>
          <th colspan="3">鱼虾蟹</th>
        </tr>
        <tr>
          <td>{{ count(arr) }}</td>
          <td>{{ singleDouble(count(arr)) | formatSingleDouble }}</td>
          <td>{{ smallBig(count(arr), 21) | formatSmallBig }}</td>
          <td>{{ fishCnname(arr[0]) }}</td>
          <td>{{ fishCnname(arr[1]) }}</td>
          <td>{{ fishCnname(arr[2]) }}</td>
        </tr>
      </table>
    </div>
    <div v-if="type.type == 'hpten'">
      <table border="0" cellpadding="1" cellspacing="1">
        <tr>
          <th colspan="3">总和</th>
          <th colspan="4">1-4龙虎</th>
        </tr>
        <tr>
          <td>{{ count(arr) }}</td>
          <td>{{ singleDouble(count(arr)) | formatSingleDouble }}</td>
          <td>{{ smallBig(count(arr), 168) | formatSmallBig }}</td>
          <!-- <td>{{smallBig((count(arr).toString()).slice(-1),5) | formatSmallBig}}</td> -->

          <td>{{ dragonTiger(arr[0], arr[arr.length - 1]) | formatDragonTiger }}</td>
          <td>{{ dragonTiger(arr[1], arr[arr.length - 2]) | formatDragonTiger }}</td>
          <td>{{ dragonTiger(arr[2], arr[arr.length - 3]) | formatDragonTiger }}</td>
          <td>{{ dragonTiger(arr[3], arr[arr.length - 4]) | formatDragonTiger }}</td>
        </tr>
      </table>
    </div>
    <div v-if="type.type == 'lhc'">
      <table border="0" cellpadding="1" cellspacing="1">
        <tr>
          <th colspan="3">总和</th>
          <th colspan="4">特码</th>
        </tr>
        <tr>
          <td>{{ count(arr) }}</td>
          <td>{{ singleDouble(count(arr)) | formatSingleDouble }}</td>
          <td>{{ smallBig(count(arr), 174) | formatSmallBig }}</td>

          <td>{{ arr[6] }}</td>
          <!-- <td>虎</td> -->
          <td>{{ singleDouble(arr[6]) | formatSingleDouble }}</td>
          <td>{{ smallBig(arr[6], 25) | formatSmallBig }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import { count, singleDouble, smallBig, dragonTiger, continuity, continuityCnname, fishCnname } from '../../helpers/resPatterns.js';

export default {
  name: 'ResPatterns',
  props: ['type', 'dataSource'],
  data() {
    return {};
  },
  computed: {
    arr() {
      return this.dataSource ? this.dataSource.split(',') : [];
    }
  },

  filters: {
    formatSingleDouble(data) {
      if (data == 0) {
        return '单';
      } else if (data == 1) {
        return '双';
      } else {
        return '';
      }
    },
    formatSmallBig(data) {
      if (data == 0) {
        return '小';
      } else if (data == 1) {
        return '大';
      } else {
        return '和';
      }
    },
    formatDragonTiger(data) {
      if (data == 0) {
        return '龙';
      } else if (data == 1) {
        return '虎';
      } else if (data == 2) {
        return '和';
      } else {
        return '和';
      }
    }
  },
  methods: {
    count,
    singleDouble,
    smallBig,
    dragonTiger,
    continuity,
    continuityCnname(x) {
      return continuityCnname[Number(x)];
    },
    fishCnname(x) {
      return fishCnname[Number(x)];
    }
  }
};
</script>
<style lang="less" scoped>
#ResPatterns {
  table {
    width: 100%;
    background: #e5e5e5;
    font-size: 14px;
    td,
    th {
      background-color: #fff;
      text-align: center;
    }
    th {
      color: #de0846;
      font-weight: normal;
      padding: 4px 0;
    }
    td {
      color: #676767;
      padding: 4px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home/ResPatterns.vue